import { Alert, Box, Card, Divider } from "@mui/material";
import localize from "../../../common/localize";
import {
  GetDateInDDMMYYYYFormat,
  getValueInCurrency,
} from "../../../common/utils";
import { getCurrencyFromSetup } from "../../../common/EntitiesManagement";

export default function BillsItem({ bill }) {
  return (
    <Card variant="outlined" className="flex flex-col gap-2 p-2">
      <Box className="flex justify-between items-center">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.code}:</b>
          </label>
          <label className="text-xs">{bill.Code}</label>
        </Box>

        <label className="text-xs">
          {GetDateInDDMMYYYYFormat(new Date(bill.GenerationDate))}
        </label>
      </Box>

      <Divider />
      <Box className="flex w-full">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.value}:</b>
          </label>
          <label className="text-xs">
            {getValueInCurrency(getCurrencyFromSetup(), bill.Value ?? 0)}
          </label>
          <label className="text-xs">
            <b>{localize.modification_date}:</b>
          </label>
          <label className="text-xs">
            {new Date(bill.ModificationDate).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </label>
          <label className="text-xs">
            <b>{localize.modified_by}:</b>
          </label>
          <label className="text-xs">{bill.CreatedBy}</label>
        </Box>
      </Box>

      {bill.Observation && (
        <Alert className="w-full" severity="info">
          <label className="text-xs">
            <b>{localize.observations}: </b>
            {bill.Observation}
          </label>
        </Alert>
      )}
    </Card>
  );
}
